import './css/common.less';
import '../bootstrap/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Tooltips from '../bootstrap/scomponents/tooltips/Tooltips';
import Toasts from '../bootstrap/scomponents/toasts/Toasts';
import startEventBackground from '../bootstrap/dom/event-background';
import DOMCustomEvents, {EVENT_LAYOUT_READY} from "../bootstrap/dom/custom-events/DOMCustomEvents";
import {getLayoutElement} from "../bootstrap/dom/element/queries";
import SinglePage from "./single-page/SinglePage";
import extendCustomForm from "./extend/custom-form";


Toasts.init();
Tooltips.init();
startEventBackground();
extendCustomForm();

const MainApp = {};

window.MainApp = MainApp;

MainApp.renderer = {
    renderSinglePage: (el, props) => ReactDOM.render(<SinglePage {...props}/>, el)
};

MainApp.callbacks = {
    dispatchLayoutReady: () => DOMCustomEvents.dispatch(EVENT_LAYOUT_READY, getLayoutElement())
};
